<template>
  <!-- ▼Main Container -->
  <div class="boss-main-container">
    <div class="boss-main-wrap boss-main-content-wrap">
      <setting-header
        :breadcrumbs="[{ name: '一次面接候補日設定', pathName: 'interviewCandidateDateTop' }]"
        title="応募者への表示日程の編集"
        data-test="title"
      />
      <form-item
        v-model="schedule.name"
        label="カレンダー名"
        class-name="boss-interview-candidate-date-edit-schedule-name"
        is-required
      >
        <template #header>
          <small>10文字以内</small>
        </template>
      </form-item>
      <form-label label="応募者に表示する日程">
        <template #body>
          応募当日から
          <select
            v-model="schedule.startDay"
            class="boss-input-select"
            data-test="schedule-start-day"
          >
            <option
              v-for="(startDay, i) in startDayOptions"
              :key="i"
              :value="startDay"
            >
              {{ startDay }}
            </option>
          </select>
          日後以降
        </template>
      </form-label>
      <form-label label="曜日一括NG設定">
        <template #body>
          <div class="display-flex">
            <div
              v-for="(day, i) in week"
              :key="i"
              class="boss-interview-candidate-date-edit-schedule-week"
            >
              <div class="boss-interview-candidate-date-edit-schedule-week-day">
                <button
                  :key="i"
                  class="boss-button boss-button-new boss-min-width-3em"
                  :data-test="`all-ng-button-${i}`"
                  @click="switchNgDayOfWeek(i)"
                >
                  {{ day }}
                </button>
              </div>
            </div>
            <div
              class="boss-interview-candidate-date-edit-schedule-week align-middle"
              data-test="week-ng-text"
            >
              ※設定時点で表示されているカレンダーのみ適用されます。
            </div>
          </div>
        </template>
      </form-label>
      <div class="boss-interview-candidate-date-edit-explain-wrap">
        <div class="boss-interview-candidate-date-edit-explain-parent">
          <div class="boss-calendar-date-candidate" />
          <p
            class="boss-interview-candidate-date-edit-explain-text"
            data-test="candidate-text"
          >
            応募者へ表示される一次面接候補日です。
          </p>
        </div>
        <div class="boss-interview-candidate-date-edit-explain-parent">
          <div class="boss-interview-candidate-date-edit-ng-explain boss-calendar-date-ng" />
          <p
            class="boss-interview-candidate-date-edit-explain-text"
            data-test="ng-text"
          >
            日付をクリックするとNG日程の選択・解除ができます。
          </p>
        </div>
      </div>
      <div class="boss-interview-candidate-date-edit-calendar">
        <interview-candidate-date-calendar
          :schedule="schedule"
          @changeNgDateCalendarEdit="changeNgDate"
        />
      </div>
      <!--登録ボタン-->
      <div class="boss-interview-candidate-date-edit-update">
        <button
          :disabled="isSubmitButtonDisabled"
          class="boss-button boss-interview-candidate-date-edit-update-button pega-button"
          data-test="submit-button"
          @click="submit"
        >
          登録
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import dayjs from 'dayjs'
import InterviewCandidateDateCalendar from '@/components/organisms/InterviewCandidateDateCalendar'
import SettingHeader from '@/components/atoms/SettingHeader'
import FormLabel from '@/components/atoms/FormLabel'
import FormItem from '@/components/atoms/FormItem'

export default {
  components: {
    SettingHeader,
    InterviewCandidateDateCalendar,
    FormLabel,
    FormItem
  },
  data () {
    return {
      schedule: {
        id: Number,
        name: '',
        startDay: 1,
        ngDates: []
      },
      // 月曜切替: isChangedDayOfWeeks[0], 火曜切替: isChangedDayOfWeeks[1],  ..., 日曜切替: isChangedDayOfWeeks[6],
      isChangedDayOfWeeks: [...Array(7)].map(_ => false)
    }
  },
  computed: {
    week: () => ['月', '火', '水', '木', '金', '土', '日'],
    startDayOptions () {
      return [...Array(14 + 1).keys()].slice(1)
    },
    // ※NG日と得る日数(今月を含めた12ヶ月のカレンダーを表示しているため、12ヶ月後の最終日と現在の差分日数にあたるもの）例）今日が2021/9/10の場合、2022/08/31までの日数を返す
    possibilityNgDatesSize () {
      return dayjs().add(11, 'M').endOf('M').diff(dayjs(), 'days') + 1
    },
    // 本日から今月の過ぎた日を除いた12ヶ月分の日付 ※一括NG曜日切替のロジックで利用する配列
    // ※今月を含めた12ヶ月のカレンダーを表示しているため、それに合わせてNG日登録ができるようにしている
    datesToOneYearLater () {
      return [...Array(this.possibilityNgDatesSize)].map((_, i) => dayjs().startOf('date').add(i, 'days'))
    },
    isSubmitButtonDisabled () {
      return this.schedule.name.trim().length === 0
    }
  },
  created () {
    this.fetchSchedule()
  },
  methods: {
    fetchSchedule () {
      this.$http.secured.get(`/interview_candidate_date/schedules/${this.$route.params.id}`)
        .then(response => {
          const schedule = response.data
          // 取得したNG日をdayjsにmapする
          schedule.ngDates = schedule.ngDates.map(ngDate => dayjs(ngDate))
          this.$set(this, 'schedule', schedule)
        })
    },
    changeNgDate (isNg, selectedDate) {
      if (isNg) {
        // 選択された時点でngの場合はng日付から外す
        const dates = this.schedule.ngDates.filter(ngDate => !dayjs(ngDate).isSame(selectedDate))
        this.schedule.ngDates = dates
      } else {
        // 選択された時点でngではない場合はng日付に追加する
        this.schedule.ngDates.push(selectedDate)
      }
    },
    switchNgDayOfWeek (dayOfWeekIndex) {
      // dayjs().format('d')で曜日番号を取得可能. 日曜なら'0', 月曜なら'1'... 土曜なら'6'を取得(日曜始まり)
      // dayOfWeekIndex: 0~6(月~日)のいずれか押された曜日が入ってくる(月曜始まり)
      // dayOfWeekIndex = 0の場合(月曜が押された場合)のtargetDayOfWeeksの値はdayjsで右記のような配列となる => [2021/8/9(月), 2021/8/16(月), ..., 2022/7/25(月), 2022/8/1(月), 2022/8/8(月)]

      // dayjsが日曜始まりなので、数値を日曜始まりに変換する
      const dayOfWeekIndexToSundayStart = [1, 2, 3, 4, 5, 6, 0][dayOfWeekIndex]
      const targetDayOfWeeks = this.datesToOneYearLater.filter(date => Number(date.format('d')) === dayOfWeekIndexToSundayStart)

      if (this.isChangedDayOfWeeks[dayOfWeekIndex]) {
        // 既に切替済みの場合、対象曜日のNG日を一括で戻す
        this.schedule.ngDates = this.schedule.ngDates.filter(ngDate => {
          return !targetDayOfWeeks.some(targetDayOfWeek => dayjs(ngDate).isSame(targetDayOfWeek))
        })
      } else {
        // 未切替の場合、対象曜日の日付をNG日として一括設定する(重複は除いて)
        this.schedule.ngDates = _.uniq(this.schedule.ngDates.concat(targetDayOfWeeks))
      }
      this.$set(this.isChangedDayOfWeeks, dayOfWeekIndex, !this.isChangedDayOfWeeks[dayOfWeekIndex])
    },
    submit () {
      const requestBody = {
        name: this.schedule.name,
        startDay: this.schedule.startDay,
        ngDates: _.uniq(this.schedule.ngDates).map(ngDate => ngDate.format('YYYY-MM-DD')) // リクエストボディに詰める際は時刻をtrunc
      }
      this.$http.secured.put(`/interview_candidate_date/schedules/${this.$route.params.id}`, requestBody).then(() => {
        this.$router.push({ name: 'interviewCandidateDateTop' })
      })
    }
  }
}
</script>
